
import { MapLocation } from '@/types/location';

// J. F. Revolution Gym Locations
export const jfRevolutionGyms: MapLocation[] = [
  {
    id: 31001,
    name: "J. F. Revolution - Riyadh (King Salman)",
    type: "Gym",
    devices: 1,
    coordinates: [24.74498520253195, 46.723948020241096],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "15-46",
    orientation: "Portrait",
    segment: "Fitness"
  }
];
